import axios from '@/libs/api.request'
// import _axios from 'axios'

// import { Toast } from 'vant';

export const login = ({ userName, password }) => {
  const data = {
    floginname: userName,
    fpassword: password,
  }
  return axios.request({
    url: 'systemuserLogin.do',
    params: data,
    method: 'get',
  })
}

export const qywxCodeLogin = ({ code, state }) => {
  const data = {
    code: code,
    state: state,
  }
  return axios.request({
    url: 'qywxCodeLogin.do',
    params: data,
    method: 'get',
  })
}
// export const getuserid = ({ code, state }) => {
//   return _axios({
//     method: 'get',
//     url: 'http://xgjapi.1000classes.com:9876/qywx/getuserid?code=' + code + '&state=' + state
//   })
// }